import React from "react";
import AppHeader from "@/components/app/AppHeader";
import AppSection from "@/components/app/AppSection";
import CardStack from "@/components/mission/CardStack";
import AppTabs from "@/components/app/AppTabs";

const tabs = [
    { key: "counco", label: "Counco" },
    { key: "reverse", label: "Reverse" },
    { key: "holo", label: "Holo" },
    { key: "ex_v", label: "EX/V" },
];

export default function AppStack() {
    const [tab, setTab] = React.useState("counco");
    return (
        <>
            <AppHeader title="Mes doubles" subtitle="Stack vendeur — Phase 4" />
            <AppSection>
                <AppTabs items={tabs} value={tab} onChange={setTab} />
                <div className="mt-8">
                    <CardStack />
                </div>
            </AppSection>
        </>
    );
}
